import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import S from "./styles";
import iconPessoasFisicas from '../../assets/icons/icon-oportunidades-pessoas-fisicas.svg'
import iconPlanilhas from '../../assets/icons/icon-planilhas.svg'
import iconOrganizadorDocumentos from '../../assets/icons/icon-organizador.svg'

import Header from "../Layout/Header";
import Footer from "../Layout/Footer";

import { Container, Flipper } from "../../components/CardFlip";
import { Sessao } from "../../helpers/Token";
import { message } from "antd";
import { useEffect } from "react";
import userflow from 'userflow.js'
import store from "../../store/configureStore";

import { setOpenModalBloqueioModulo } from "../../store/actions/termos";

import ModalBloqueioModulo from "./ModalBloqueioModulo";


const urlImage = "https://images.e-auditoria.com.br/erecuperador/bemvindo";
const IconSimplesNacional = `${urlImage}/simples-nacional/padrao.svg`;
const IconLucroReal = `${urlImage}/lucro-real/padrao.svg`;
const IconGerenciador = `${urlImage}/gerenciador/padrao.svg`;
const IconMultiplicador = `${urlImage}/multiplicador/e-mult-icon-rec.svg`;
const IconDiagnosticoRCT = `${urlImage}/diagnostico/icon-diagnostico.svg`;
const IconOrganizador = iconOrganizadorDocumentos;
const IconOportunidadesPessoasFisicas = iconPessoasFisicas;
const IconPlanilhasCalculo = iconPlanilhas;

function isPlanoMeuPrimeiroClienteCompleto() {
  const planoMeuPrimeiroClienteCompleto = Sessao('planoMeuPrimeiroClienteCompleto');
  if (planoMeuPrimeiroClienteCompleto === true) return true;
  return false;
}

function isOcultarPlanilhaCalculo() {
  const ocultarPlanilhaCalculo = Sessao('ocultarPlanilhaCalculo');
  if (ocultarPlanilhaCalculo === true) return true;
  return false;
}

function isPlanoMaster() {
  const planoMaster = Sessao('planoMaster');
  if (planoMaster === true && !isPlanoProfissionalLiberalSimples()) {
    return true
  }
  return false;
}

function isPlanoTeste() {
  const planoTeste = Sessao('planoTeste');
  if (planoTeste === true) {
    return true
  }
  return false;
}

function isPlanoProfissionalLiberalSimples () {
  return Sessao('planoProfissionalLiberalSimples') === true;
}


function isPlanoRecuperadorLimitado() {
  if(!isPlanoMeuPrimeiroClienteCompleto())
  {
    return Sessao('planoRecuperadorLimitado') === true;
  }
}

function Welcome() {
  const isPlanoRecLimitado = isPlanoRecuperadorLimitado();
  const isPlanoTest = isPlanoTeste();
  
  const history = useHistory();
  const [smallDevice, setSmallDevice] = useState(window.matchMedia("(max-width: 950px)").matches)
  const [organizadorDesabilitado, setOrganizadorDesabilitado] = useState(isPlanoRecLimitado || isPlanoTest);


  const MSG_PLANO_LIMITADO = 'Para você que faz parte do plano Diagnóstico RCT, essa ferramenta não está liberada. Adiquira o Plano Master para ter acesso. Temos uma oferta com condições especiais para você!';
  const MSG_PLANO_TESTE = 'Para você que está em fase de teste, essa ferramenta não está liberada. Adiquira o Plano Master para ter acesso. Temos uma oferta com condições especiais para você!';

  const setTooltip = () => {
    if (isPlanoRecLimitado)
      return MSG_PLANO_LIMITADO;

    if (isPlanoTest)
      return MSG_PLANO_TESTE;

    return null;
  };

  useEffect(() => {
    const handler = e => setSmallDevice(e.matches);
    window.matchMedia("(max-width: 950px)").addEventListener('change', handler);

    return () => {
      window.matchMedia("(max-width: 950px)").removeEventListener('change', handler);
    }
  }, [])

    useEffect(()=>{
  
      function getCookieValue(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      }
  
      const userIdKeycloak = getCookieValue('UserId');
      const email = sessionStorage.getItem('email')
      const TOKEN = "ct_xwktivwprzdtdkj4wsfia47hhy";
  
      userflow.setResourceCenterLauncherHidden(true);
      userflow.init(TOKEN);
      userflow.identify(userIdKeycloak + '', {
        email: email,
      });
  
    },[])
  

  return (
    <>
      <ModalBloqueioModulo />

      <Header />

      <S.Welcome>
        <S.Intro>
          <S.Intro.Title>seja bem-vindo!</S.Intro.Title>
          <S.Intro.Description>
            Plataforma destinada à exploração das diversas oportunidades ligadas
            à Recuperação de Créditos Tributários para empresas do Simples
            Nacional, Lucro Real e Presumido e para Pessoas Físicas.
          </S.Intro.Description>
        </S.Intro>
        <S.MainContainer>
          <Container>
            <Flipper
              back={false}
              icon={IconSimplesNacional}
              title="oportunidades para empresas optantes pelo simples nacional"
              onClick={() => history.push("/bemvindo/simples-nacional")}
            />

            {(isPlanoMaster() || isPlanoTeste()) && <Flipper
              back={false}
              icon={IconLucroReal}
              title="oportunidades para empresas optantes pelo lucro real e presumido"
              onClick={() => history.push("/bemvindo/lucro-real-presumido")}
            />}

            <Flipper
              back={false}
              icon={IconOportunidadesPessoasFisicas}
              title="oportunidades para pessoas físicas"
              onClick={() => history.push("/bemvindo/oportunidades-pessoas-fisicas")}
            />

            <Flipper
              back={false}
              icon={IconOrganizador}
              title="organizador de documentos"
              tooltipTitle={setTooltip()}
              desabilitado={isPlanoRecLimitado || isPlanoTest }
              onClick={() => {
                if(!isPlanoMeuPrimeiroClienteCompleto())
                {
                  window.location.href = process.env.REACT_APP_ORGANIZADOR_URL
                } else {
                  store.dispatch(setOpenModalBloqueioModulo(true));
                }    
              }}
            />

          </Container>
        </S.MainContainer>
        <S.MainContainer2>
          <Container>
            <Flipper
              back={false}
              icon={IconDiagnosticoRCT}
              title="diagnóstico de oportunidades de recuperação de créditos tributários"
              onClick={() => {
                window.location.href = process.env.REACT_APP_DIAGNOSTICO_RCT
              }}
            />

            <Flipper
              back={false}
              icon={IconGerenciador}
              title="gerenciador de propostas e contratos"
              onClick={() =>
                history.push("/bemvindo/gerenciador-propostas-contratos")
              }
            />

            {/* O módulo e-Multiplicador está indisponível até segunda ordem.
            <Flipper
              back={false}
              icon={IconMultiplicador}
              title="e-Multiplicador"
              onClick={() => {
                if (isPlanoTeste()) {
                  message.error('Módulo não disponível para contas de teste')
                } else {
                  window.location.href = "https://emultiplicador.e-auditoria.com.br"
                }
              }}
            />*/}

            {!isOcultarPlanilhaCalculo() && <Flipper
              back={false}
              icon={IconPlanilhasCalculo}
              title="E-Planilhas"
              onClick={() => history.push("/bemvindo/e-planilhas")}
            />}

          </Container>
        </S.MainContainer2>
      </S.Welcome>

      <Footer />
    </>
  );
}

export default Welcome;
